import { useContext } from 'react';

import { ReloadableConfig } from '../../types/config.types';
import { AppContextState } from '../context';
import { AppContext } from '../context/AppContext.context';

export const useToggles = (): ReloadableConfig => {
  const context = useContext<AppContextState>(AppContext);
  return context.config.toggles;
};
